import { Component, QueryList, Input, OnInit, Host, ViewChild, ContentChildren, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';

@Component({
    selector: 'carousel-slide',
    template: `
    <div [@flyPosition]="flyPosition" (@flyPosition.done)="onAnimationDone($event)">    
        <ng-content  *ngIf="selected"></ng-content>
    </div>
  `,
    styles: [
        ':host { position:absolute }',
        ':host { overflow:hidden }'
    ],
    animations: [
        trigger('flyPosition', [
           transition('selected => left', [style({ transform: 'translateX(0)' }), animate('2s ease-out', style({ transform: 'translateX(-100%)' }))]),
            transition('selected => right', [style({ transform: 'translateX(0)' }), animate('2s ease-out', style({ transform: 'translateX(100%)' }))]),
            transition('left => selected', [style({ transform: 'translateX(-100%)' }), animate('2s ease-out', style({ transform: 'translateX(0)' }))]),
            transition('right => selected', [style({ transform: 'translateX(100%)' }), animate('2s ease-out', style({ transform: 'translateX(0)' }))]),
        ]),
    ],
})
export class PageComponent {
    @Input() selected: boolean = false;
    flyPosition = 'right';

    constructor(private _cdr: ChangeDetectorRef) {
    }

    onAnimationDone(event:any) {
        // hide a slide after animation completes
        if (event.fromState != 'void' && event.toState != 'selected' && this.flyPosition != 'selected') {
            this.selected = false;
        }

        // set the flyPosition for the selected element when it's first displayed
        if (event.fromState == 'void' && this.selected) {
            this.flyPosition= "selected";
        }
    }

    select() {
        this.selected = true;
        this.flyPosition= "selected";
        this._cdr.detectChanges();
    }
}
